import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['El budín queda seco', 'Se hunde en el centro', 'No tiene buen sabor', 'La receta no sale como esperabas'];
  return <section className="py-20 px-4" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#3D2B1F]" data-id="element-123">
          Si alguna vez intentaste hacer budines en casa,{' '}
          <span className="text-red-500" data-id="element-124">seguramente te pasó esto:</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-125">
          {problems.map((problem, index) => <div key={index} className="bg-white p-6 rounded-2xl border border-red-200 flex items-center gap-4 transform transition-all hover:-translate-y-1 hover:border-red-300 shadow-sm" data-id="element-126">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-127" />
              <p className="text-lg text-[#3D2B1F] font-medium" data-id="element-128">{problem}</p>
            </div>)}
        </div>

        <p className="text-2xl text-center text-[#9B8578] font-medium italic" data-id="element-129">
          Y terminás pensando que hacer budines perfectos es complicado.
        </p>
      </div>
    </section>;
}